import React, {useState} from 'react';
import {DeleteOutlineIcon} from '../../../ui-library';
import {ModalBox, ImageBox, GalleryBox, ExitIcon, DeleteButton, ArrowBackIcon, ArrowForwardIcon, FabBtnLeft, FabBtnRight, StyledImg} from '../Style/AutoClassGallery.style';
import useAutoClassGallery from '../Controller/AutoClassGallery.controller';
import {FLOW} from '../../../pages/RandomSampler/Config/RandomSampler.constants';
import {default as BeforeExitModal} from '../../BeforeExitModal/View/BeforeExitModal.view';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';


const AutoClassGalleryView = ({itemData, onDeleteFile, chosenImage, open, setOpen, currentImageIndex, setCurrentImageIndex, setCurrentImage, flow}) => {
    const { isStartOfList, isEndOfList, handlePrevImage, handleNextImage, findChosenImageIndex, handleDeleteBtnClick, closeModalByScreenSize} = useAutoClassGallery({ itemData, chosenImage, open, setOpen, currentImageIndex, setCurrentImageIndex, onDeleteFile, setCurrentImage});
    const showDelete = [FLOW.classImages, FLOW.autoClasses].includes(flow) && !(itemData[currentImageIndex]?.disable);
    const [isOpenDeleteDialog, setIsOpenDeleteDialog] = useState(false);


    return (
        <>
            {closeModalByScreenSize()}
            <BeforeExitModal
                title={_SYSTEM_TITLES.WhatsInTheDataDeleteSubClusterTitle}
                content={_SYSTEM_TITLES.WhatsInTheDataDeleteSubClusterContent}
                yesTitle={_SYSTEM_TITLES.WhatsInTheDataDeleteSubClusterConfirmBtn}
                cancelTitle={_SYSTEM_TITLES.WhatsInTheDataDeleteSubClusterCancelBtn}
                open={isOpenDeleteDialog}
                setOpen={setIsOpenDeleteDialog}
                onClick={() => {
                    handleDeleteBtnClick(itemData[currentImageIndex]);
                    setIsOpenDeleteDialog(false);
                }}/>
            <ModalBox
                open={open}>
                <>
                    <ExitIcon onClick={() => setOpen(false)}/>
                    <FabBtnLeft onClick={handlePrevImage} disabled={isStartOfList}>
                        <ArrowBackIcon />
                    </FabBtnLeft>
                    <GalleryBox>
                        <ImageBox>
                            {showDelete && <DeleteButton startIcon={<DeleteOutlineIcon/>} size='medium' variant='outlined'
                                onClick={() =>
                                    (flow === FLOW.classImages
                                        ? handleDeleteBtnClick(itemData[currentImageIndex]) : setIsOpenDeleteDialog(true))}>Delete</DeleteButton>}
                            {itemData[currentImageIndex]?.url && <StyledImg
                                src={currentImageIndex > -1 ? itemData[currentImageIndex].url : itemData[findChosenImageIndex()].url}
                                alt='image'
                            />}
                        </ImageBox>
                    </GalleryBox>
                    <FabBtnRight onClick={() => handleNextImage(false)} disabled={isEndOfList}>
                        <ArrowForwardIcon />
                    </FabBtnRight>
                </>
            </ModalBox>
        </>
    );
};

export default AutoClassGalleryView;

